<template>
  <div>
    <h1>Edit {{ retrieved && retrieved['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>

    <InfoForm
      v-if="retrieved"
      :handle-submit="onSendForm"
      :values="retrieved"
      :errors="violations"
      :initial-values="retrieved" />

    <div class="my-3">
      <router-link
        v-if="retrieved"
        :to="{ name: 'InfoList' }"
        class="btn btn-primary mr-3">Back to list</router-link>     
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import InfoForm from './Form.vue';

export default {
  components: {
    InfoForm,
  },

  computed: {
    ...mapFields('speaker/create', {
      created: 'created',
    }),
    ...mapFields('speaker/update', {
      isLoading: 'isLoading',
      error: 'error',
      retrieved: 'retrieved',
      updated: 'updated',
      violations: 'violations',
    }),
  },

  watch: {
    updated: function(updated) {
       if (!updated) {
        return;
      }
      this.$router.push({ name: 'InfoList' });
    }
  },

  beforeDestroy() {
    this.reset();
  },

  created() {
    this.retrieve(decodeURIComponent(this.$route.params.id));
  },

  methods: {
    ...mapActions({
      createReset: 'speaker/create/reset',
      delReset: 'speaker/del/reset',
      retrieve: 'speaker/update/retrieve',
      updateReset: 'speaker/update/reset',
      update: 'speaker/update/update',
      updateRetrieved: 'speaker/update/updateRetrieved',
    }),

    reset() {
      this.updateReset();
      this.createReset();
    },

    onSendForm(data) {
      this.update(data);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/info/Update.vue